import { createApp } from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import i18n from '@/i18n';
import VueGtag from 'vue-gtag';

const app = createApp(App);

app.use(router); // router first


console.log('Before VueGtag setup');

app.use(VueGtag, {
    config: { id: 'G-VPWDW1X5W7' },
    enabled: true,
    debug: true,
    appName: 'MyVueApp',
    pageTrackerScreenviewEnabled: true
}, router);


console.log('After VueGtag setup');


app.use(store);
app.use(i18n);
app.mount('#app');

